import { buildBindable } from '@monofe/di';
import type { IStoresRenderer } from '../interface';
import {
    bindStoresRenderer,
    injectStoresData,
    injectStoresRenderer,
    TYPES,
    unbindStoresRenderer,
} from '../interface';
import renderer from './StoreRender';

export default buildBindable<IStoresRenderer>({
    id: TYPES.IStoresRenderer,
    dependencies: [TYPES.IStoresData],
    bind: bindStoresRenderer,
    remove: unbindStoresRenderer,
    inject: injectStoresRenderer,
    build: container => {
        const stores = injectStoresData(container);
        return Promise.resolve(renderer(stores));
    },
});
